import {http_client} from "../plugins/http_client";

const obtenerHistoricoRenta = async (idNominaPlanilla, params = {}) => await http_client(`/api/renta/historico/${idNominaPlanilla}`, params, 'GET');
const crearHistoricoRenta = async (body) => await http_client('/api/renta/historico', body, 'post', { headers: { "content-type": "multipart/form-data" } });
const aplicarRentaMensual = async (body) => await http_client('/api/renta/aplicar-renta-mensual', body, 'put');

const descargarPlantillaHistorico = async () => await http_client('/api/gestion-planilla/planilla/renta/historico/plantilla', {}, 'get', {}, true, 'blob');
const importarHistoricoRenta = async (formData) => await http_client('/api/gestion-planilla/planilla/renta/historico/importar', formData, 'post', { 'Content-Type': 'multipart/form-data' }, true, 'json');
const estadoImportacionHistorico = async (id) => await http_client(`/api/gestion-planilla/planilla/renta/historico/importar/${id}/estado`, {}, 'get');
const erroresImportacionHistorico = async (id, params = {}) => await http_client(`/api/gestion-planilla/planilla/renta/historico/importar/${id}/errores`, params, 'get');
const listarCargasHistoricoRenta = async (params = {}) => await http_client('/api/gestion-planilla/planilla/renta/historico/cargas', params, 'get');
const empleadosCargadosHistoricoRenta = async (idCarga, params = {}) => await http_client(`/api/gestion-planilla/planilla/renta/historico/cargas/${idCarga}/empleados`, params, 'get');
const eliminarEmpleadoHistoricoRenta = async (idCarga, idDetalle) => await http_client(
    `/api/gestion-planilla/planilla/renta/historico/cargas/${idCarga}/empleados/${idDetalle}`,
    {},
    'delete',
    {},
    true,
    'json',
    undefined,
    true
);

export default {
    obtenerHistoricoRenta,
    crearHistoricoRenta,
    aplicarRentaMensual,
    descargarPlantillaHistorico,
    importarHistoricoRenta,
    estadoImportacionHistorico,
    erroresImportacionHistorico,
    listarCargasHistoricoRenta,
    empleadosCargadosHistoricoRenta,
    eliminarEmpleadoHistoricoRenta,
}
